// @services/globalDialogBus.js

// import mitt
import mitt from 'mitt';

// global toast bus
const DialogBus = mitt();

// export the bus
export default DialogBus;